export default "__VITE_ASSET__Jhiobz1iAIl42UC3k5$exQ__"